import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  text: {
    fontWeight: 400,
    fontSize: 11,
    lineHeight: '1.8px',
    color: colors.neutral900,
  },

  bottomContainer: {
    maxWidth: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
  },

  supplierData: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 10,
  },

  title: {
    marginBottom: '10px',
    textTransform: 'uppercase',
    fontWeight: 700,
    lineHeight: '1px',
  },
});
